import { Button, HStack } from "@chakra-ui/react"

interface ChartRangeSelectorProps<T extends string> {
  options: { value: T; label: string }[]
  value: T
  onChange: (value: T) => void
}

export const ChartRangeSelector = <T extends string>({ options, value, onChange }: ChartRangeSelectorProps<T>) => (
  <HStack gap={2}>
    {options.map((option) => (
      <Button
        key={option.value}
        size="xs"
        variant={value === option.value ? "solid" : "outline"}
        colorScheme={value === option.value ? "blue" : "gray"}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </Button>
    ))}
  </HStack>
)
